import VaWorksApi from '@/api/VaWorksApi'

export const user = {
  namespaced: true,
  state: {
    userProfile: null
  },
  actions: {
    loadProfile ({commit}) {
      VaWorksApi().get('Profile')
        .then((r) => {
          commit('setProfile', r.data)
        })
        .catch((e) => {
          console.log(e)
        })
    }
  },
  mutations: {
    setProfile (state, profile) {
      state.userProfile = profile
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/user/index.js